<template>
  <div class="wrapper log-bg">
    <div class="header-area bg-transparent border-0">
      <div class="container-fluid">
        <div class="row">
          <div class="col-6">
            <a @click="$router.go(-1)" href="javascript:;">
              <span class="back-arrow mt-4"></span>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="body-area pb-0">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12">
            <div class="text-center pb-5">
              <img src="/static/img/logo.png" alt />
            </div>
          </div>
          <div class="col-12">
            <div class="warning fs-12 fc-3 py-2 px-3">
              Aşağıdaki formdaki bilgiler T.C kimlik kartında
              yazıldığı şekilde doldurulmalıdır.
            </div>
          </div>
          <div class="col-12">
            <input
              type="email"
              v-model="form.register_mail"
              class="form-input"
              placeholder="E-posta adresin"
            />
            <input
              type="password"
              v-model="form.register_pass"
              class="form-input"
              placeholder="Şifre"
            />
            <input
              type="text"
              class="form-input"
              v-model="form.register_pass_retry"
              placeholder="Şifre Tekrar"
            />
            <input type="text" v-model="form.register_name" class="form-input" placeholder="Adın" />
            <input
              type="text"
              v-model="form.register_surname"
              class="form-input"
              placeholder="Soyadın"
            />
            <input
              type="text"
              v-mask="'##/##/####'"
              v-model="form.register_birthday"
              class="form-input"
              placeholder="Doğum Tarihin"
            />
            <input
              type="text"
              class="form-input"
              v-mask="'### ### ### ##'"
              v-model="form.register_tckn"
              placeholder="TC Kimlik No"
            />
            <select class="form-select" v-model="form.select_gender">
              <option :value="null">Cinsiyet</option>
              <option :value="i.value" v-for="i in genders" :key="i.value">{{i.title}}</option>
            </select>
            <input
              type="text"
              v-mask="'(###) ### ## ##'"
              v-model="form.register_phone"
              class="form-input"
              placeholder="Cep Telefonu Numaran"
            />
            <select class="form-select" v-model="form.cityId">
              <option :value="null">Yaşadığın Şehir</option>
              <option :value="i.id" v-for="i in cities" :key="i.id">{{i.name}}</option>
            </select>
            <select class="form-select" v-model="form.district">
              <option :value="null">Yaşadığın İlçe</option>
              <option :value="i.id" v-for="i in districts" :key="i.id">{{i.name}}</option>
            </select>
            <select class="form-select" v-model="form.career">
              <option :value="null">Meslek</option>
              <option :value="i.name" v-for="i in professionList" :key="i.id">{{i.name}}</option>
            </select>
          </div>

          <div class="col-12 fs-14 fc-3">
            <div class="form-check checkbox-custom">
              <input
                class="form-check-input"
                type="checkbox"
                v-model="form.allowEmail"
                :value="1"
                id="defaultCheck3"
              />
              <label class="form-check-label" for="defaultCheck3">
                Anadolu Efes Spor Kulübü’nden e-posta
                almayı kabul ediyorum.
              </label>
            </div>
            <div class="form-check checkbox-custom">
              <input
                class="form-check-input"
                type="checkbox"
                :value="1"
                v-model="form.allowSms"
                id="defaultCheck4"
              />
              <label class="form-check-label" for="defaultCheck4">
                Anadolu Efes Spor Kulübü’nden SMS
                almayı kabul ediyorum.
              </label>
            </div>
            <div class="form-check checkbox-custom">
              <input
                class="form-check-input"
                v-model="form.term"
                type="checkbox"
                :value="1"
                id="defaultCheck2"
              />
              <label class="form-check-label" for="defaultCheck2">
                <span>
                  <span class="fc-1 font-weight-bold" @click="termModal = true">Katılım koşulları</span>nı okudum kabul ediyorum.
                </span>
              </label>
            </div>
          </div>
          <div class="col-12 mt-5">
            <button class="confirm-button" @click="register">Üye Ol</button>
          </div>
        </div>
      </div>
    </div>

    <el-dialog width="90%" :visible.sync="termModal" title="Katılım koşulları">
      <div v-html="term"></div>
    </el-dialog>
  </div>
</template>


<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Menu from "@/components/Menu";
import { mask } from "vue-the-mask";
import axios from "axios";
import moment from "moment";

export default {
  name: "Register",
  components: {
    Footer,
    Menu,
    Header
  },
  directives: { mask },
  data() {
    return {
      form: {
        register_name: null,
        register_surname: null,
        register_mail: null,
        register_pass: null,
        register_pass_retry: null,
        select_gender: null,
        register_birthday: null,
        register_phone: null,
        register_tckn: null,
        allowEmail: false,
        allowSms: false,
        cityId: null,
        district: null,
        career: null,
        term: false,
        permission: false
      },
      genders: [
        {
          title: "Erkek",
          value: 1
        },
        {
          title: "Kadın",
          value: 2
        },
        {
          title: "Belirtmek İstemiyorum",
          value: 0
        }
      ],
      cities: [],
      districts: [],
      termModal: false,
      professionList: [],
      term: null
    };
  },
  beforeMount() {
    axios.get("statik/il-listesi?country_id=190").then(res => {
      this.cities = res.data;
    });

    axios.post("statik/meslek-listesi").then(res => {
      this.professionList = res.data;
    });

    axios.post("statik/kullanim-sartlari").then(res => {
      this.term = res.data.data;
    });
  },
  methods: {
    getDistrict() {
      var data = new FormData();
      data.append("cityId", this.form.cityId);
      axios.post("statik/ilce-listesi", data).then(res => {
        this.districts = res.data;
      });
    },
    register() {
      var data = new FormData();

      data.append(
        "mystr",
        JSON.stringify({
          ...this.form,
          register_birthday: this.form.register_birthday
          ,
          register_tckn: this.form.register_tckn
            .replace(" ", "")
            .replace(" ", "")
            .replace(" ", "")
            .replace(" ", "")
            .replace(" ", ""),
          register_phone: this.form.register_phone
            .replace("(", "")
            .replace(")", "")
            .replace(" ", "")
            .replace(" ", "")
            .replace(" ", "")
            .replace(" ", "")
            .replace(" ", "")
        })
      );

      axios
        .post("uyelik/kayit", data)
        .then(res => {
          if (res.data.StatusCode == 200) {
            this.$notify({
              title: "Kayıt Başarılı",
              message:
                "Üyeliğiniz başarıyla oluşturulmuştur. Lütfen e-posta adresine gönderilen yönergeleri izleyerek üyeliğinizi aktif edin. Aktif ettikten sonra giriş yapabilirsiniz.",
              type: "success"
            });

            this.$router.push({ name: "Activate" });
          } else {
            this.$notify({
              title: "Hata",
              message: res.data.Message,
              type: "error"
            });
          }
        })
        .catch(err => {});
    }
  },
  watch: {
    "form.cityId": function() {
      this.getDistrict();
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/Register.vue